import clsx from 'clsx';
import React from 'react';
import ReactHtmlParser from 'react-html-parser';

import styles from './styles.module.scss';

interface TakeawayProps {
  takeaway: string;
}

const Takeaway = ({ takeaway }: TakeawayProps) => {
  return (
    <div
      className={clsx(
        styles.takeawayContainer,
        '-mx-16 my-32 bg-grayscale-charcoal px-20 py-[38px] sm:-mx-28 sm:py-48 sm:pl-32 sm:pr-64 md:float-left md:my-0 md:-ml-[88px] md:mr-20 md:w-[348px] md:p-48 lg:-ml-[320px] lg:w-[638px] lg:pb-56 lg:pr-[45px] lg:pt-24 xl:mr-40'
      )}
    >
      <div className="font-suisse-neue text-body-lg text-white print:text-black md:ml-auto md:max-w-[356px]">
        <h3 className="m-0 mb-16 border-0 border-b border-solid border-grayscale-gray pb-16 !font-suisse-intl-mono text-body-takeaway text-white print:text-black">
          The Takeaway
        </h3>
        {ReactHtmlParser(takeaway.replace(/\n|\r/g, ''))}
      </div>
    </div>
  );
};

export default Takeaway;
